import { AUTH_REDIRECT, fetchAPI } from '../../utils/apiUtils';

// 단일 OCR도 공유 인증을 사용하되 HTTP 상태와 data.reason을 잃지 않는다.
async function request(path, getAccessToken, { method = 'GET', body, multipart = false } = {}) {
  const token = await getAccessToken();
  if (!token) { window.location.href = '/signin'; return AUTH_REDIRECT; }
  let response;
  try {
    response = await fetchAPI(`/api/v2/ocr${path}`, {
      method,
      headers: { Authorization: token, ...(!multipart && body !== undefined ? { 'Content-Type': 'application/json' } : {}) },
      ...(body !== undefined ? { body: multipart ? body : JSON.stringify(body) } : {}),
    });
  } catch (_) {
    const error = new Error('응답을 받지 못했습니다. 작업 상태를 확인한 뒤 다시 시도해 주세요.');
    error.uncertain = true;
    throw error;
  }
  if (response.status === 401) {
    localStorage.removeItem('accessToken'); localStorage.removeItem('refreshToken');
    window.location.href = '/signin'; return AUTH_REDIRECT;
  }
  let envelope;
  try { envelope = await response.json(); } catch (_) { /* 상태와 재조회 필요 여부를 아래에서 보존 */ }
  if (!response.ok || envelope?.status !== 'success') {
    const error = new Error(envelope?.message || `작업 응답을 확인하지 못했습니다. (${response.status})`);
    error.httpStatus = response.status;
    error.data = envelope?.data ?? null;
    error.uncertain = !envelope;
    throw error;
  }
  return envelope.data;
}

export const listSingleOcr = ({ state = 'open', page = 1 } = {}, token) =>
  request(`/single?${new URLSearchParams({ state, page, per_page: 10 })}`, token);
export const getSingleOcr = (id, token) => request(`/single/${id}`, token);
export const deleteSingleOcr = (id, token) => request(`/single/${id}`, token, { method: 'DELETE' });
export const saveSingleOcr = (id, token) => request(`/single/${id}/save`, token, { method: 'POST' });
export function createSingleOcr(file, name, token) {
  const body = new FormData(); body.append('file', file);
  if (name.trim()) body.append('name', name.trim());
  return request('/single', token, { method: 'POST', body, multipart: true });
}
export function readSingleOcr(id, { pageId, bbox, userPrompt }, token) {
  return request(`/single/${id}/read`, token, {
    method: 'POST', body: { page_id: pageId, ...(bbox ? { bbox } : {}), ...(userPrompt?.trim() ? { user_prompt: userPrompt.trim() } : {}) },
  });
}
export const analyzeSingleOcr = (id, userPrompt, token) => request(`/single/${id}/analyze`, token, {
  method: 'POST', body: userPrompt?.trim() ? { user_prompt: userPrompt.trim() } : {},
});
